import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../Layout";
import useUserStore from "../../../utils/storeApp";
import HeaderNotify from "./HeaderNotify";
import CallAPI from "../../../services/apiCalls";

const NotifyApp = () => {
  const navigate = useNavigate();
  const { isUserLogedIn, userRole, userToken, SetSharedObject } = useUserStore(
    (state) => ({
      isUserLogedIn: state.isUserLogedIn,
      userRole: state.userRole,
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
    })
  );

  const [URL, SetURL] = useState("");
  const [processingDetails, setProcessingDetails] = useState(false);

  useEffect(() => {
    setProcessingDetails(true);
    GetURL();
  }, []);

  const GetURL = async () => {
    let call = "/notifyApp/GetURL";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      var url = res.data;
      SetURL(url);
    } else if (res.status === "SERVERERROR") {
      //setProcessing(false);
    }
  };

  function finishedLoading() {
    setProcessingDetails(false);
  }
  return (
    <Layout>
      <HeaderNotify />
      <section className="layout-container">
        <div className="right-content-padding">
          <iframe
            id="iframeId"
            src={URL}
            style={{ width: "100%", height: "100vh", border: "none" }}
            title="Notify Application"
            onLoad={finishedLoading}
          ></iframe>
          {processingDetails ? (
            <div
              className="modal fade show"
              id="detailsOrgModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="DetailsOrganization"
              data-backdrop="static"
              style={{ display: "block" }}
            >
              <div 
                    className="loader-container" 
                    role="status" 
                    aria-live="polite" 
                    aria-atomic="true"
                    aria-labelledby="notify-app-loader"
                >
                  <div className="spinner" aria-hidden="true"></div>
                  <div className="loading-text" id="notify-app-loader">Loading...</div>
                </div>
            </div>
          ) : null}
        </div>
      </section>
    </Layout>
  );
};

export default NotifyApp;
